module.exports = __webpack_public_path__ + "img/earth.a40414b2.png";